module.exports = __webpack_public_path__ + "i18n/ro.9dd7243e1935c288aff2870acdfef72c.json";